export default __webpack_public_path__ + "c25ab3c7322e2b8547b39f8d77df7749.svg";